import { create } from 'zustand';

export const useLightboxStore = create((set, get) => ({
  _imagesByKey: {},
  _activeKey: null,
  isOpen: false,
  currentIndex: 0,

  setImages: (key, images) => set((state) => ({
    _imagesByKey: { ...state._imagesByKey, [key]: images },
  })),

  removeImages: (key) => set((state) => {
    const { [key]: _, ...rest } = state._imagesByKey;
    return { _imagesByKey: rest };
  }),

  openBySource: (src) => {
    const { _imagesByKey } = get();

    // Find which key owns this image
    for (const [key, images] of Object.entries(_imagesByKey)) {
      const index = (images || []).findIndex((img) => img?.src === src);
      if (index !== -1) {
        set({ isOpen: true, currentIndex: index, _activeKey: key });
        return;
      }
    }
  },

  getActiveImages: () => {
    const { _imagesByKey, _activeKey } = get();
    return (_activeKey && _imagesByKey[_activeKey]) || [];
  },

  closeLightbox: () => set({ isOpen: false, _activeKey: null }),
}));
